import { Inbox } from "lucide-react";
import type { FunctionComponent, ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { cn } from "./cn";

export interface EmptyProps {
  /** Default "No data" (`common:noDataFound`); `false` hides it. */
  description?: ReactNode;
  /** Replaces the default inbox icon. */
  image?: ReactNode;
  /** Footer content, e.g. a call-to-action button. */
  children?: ReactNode;
  className?: string;
}

/** Empty-state placeholder (antd `Empty` replacement). */
export const Empty: FunctionComponent<EmptyProps> = ({ description, image, children, className }) => {
  const { t } = useTranslation();

  return (
    <div className={cn("my-8 flex flex-col items-center text-center text-sm text-noa-muted", className)}>
      <div className="mb-2 text-noa-muted">{image ?? <Inbox className="size-10" strokeWidth={1.25} />}</div>
      {description !== false && <div>{description ?? t("common:noDataFound")}</div>}
      {children && <div className="mt-4">{children}</div>}
    </div>
  );
};
